export default "__VITE_ASSET__DIc_Mf2U__"